import { showAutoClosingAlert } from "../alerts/alerts";
import { newAlertMessage } from "../components/alert-message";
import {
  CallbackWithAutoClosingAlertHook,
  CallbackWithAutoClosingAlertHook_Inner,
} from "../data-types";

export const callbackWithAutoClosingAlert: CallbackWithAutoClosingAlertHook = (
  callback,
  message
) => {
  const callbackWithAutoClosingAlert: CallbackWithAutoClosingAlertHook_Inner = async (
    newMessage = null,
    ...args
  ) => {
    const m = newMessage ? newMessage : message ? message : { success: null, error: null };
    try {
      await callback(...args);
      m.success && showAutoClosingAlert(newAlertMessage("success", m["success"]));
    } catch (e) {
      m.error && showAutoClosingAlert(newAlertMessage("error", m["error"]));
    }
  };

  return callbackWithAutoClosingAlert;
};
